import CustomerInfoBlock, { CustomerInfoBlockProps } from './CustomerInfoBlock';

export type { CustomerInfoBlockProps };
export default CustomerInfoBlock;
